import React from "react";
import { userColumnsConfig } from "../config/Users";

export const getUserColumns = ({ onDeleteClick, onRowClick, onCreateBookingClick, onEditClick }) => {
  return [
    {
      name: <span className="font-weight-bold fs-13">Name</span>,
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => (
        <div
          className="cursor-pointer w-100"
          onClick={() => onRowClick(row)}
        >
          {row.name}
        </div>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">Email</span>,
      selector: (row) => row.email,
      sortable: true,
      cell: (row) => (
        <div
          className="cursor-pointer w-100"
          onClick={() => onRowClick(row)}
        >
          {row.email}
        </div>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">Phone No</span>,
      selector: (row) => row.mobileNo,
      sortable: true,
      cell: (row) => (
        <div
          className="cursor-pointer w-100"
          onClick={() => onRowClick(row)}
        >
          {row.mobileNo}
        </div>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">Login Type</span>,
      selector: (row) => row.loginType,
      sortable: true,
      cell: (row) => (
        <div
          className="cursor-pointer"
          onClick={() => onRowClick(row)}
        >
          <span className="badge bg-info-subtle text-info text-uppercase">
            {row.loginType || "N/A"}
          </span>
        </div>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">{userColumnsConfig.ACTIONS}</span>,
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-center gap-2">
          {/* Edit action */}
          <div
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onEditClick && onEditClick(row);
            }}
            className="text-decoration-none px-1 py-2 cursor-pointer"
            title="Edit"
          >
            <i className="ri-edit-line fs-13 p-2 rounded-circle shadow-sm bg-f1" style={{ color: "#00209f" }} />
          </div>

          <div
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onDeleteClick && onDeleteClick(row);
            }}
            className="text-decoration-none px-1 py-2 cursor-pointer"
            title="Delete"
          >
            <i className="ri-delete-bin-7-fill fs-13 text-danger p-2 rounded-circle shadow-sm bg-f1" />
          </div>

          {/* Create Booking action - Updated */}
          <div
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onCreateBookingClick && onCreateBookingClick(row);
            }}
            className="text-decoration-none px-1 py-2 cursor-pointer"
            title="Create Booking"
          >
            <i className="ri-calendar-check-fill fs-13 p-2 rounded-circle shadow-sm bg-f1" style={{backgroundColor: '#00209f'}}/>
          </div>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "150px",
    },
  ];
};